<div *ngIf="isRunning() && isAllowed"
  class="cs-rest-timer-pill-wrapper"
  [class.cs-rest-timer-pill--expired]="isExpired()"
>
  <div
    class="cs-rest-timer-pill"
    (click)="onTap()"
    (keydown)="onKeyDown($event)"
    role="button"
    tabindex="0"
  >
    <cs-icon [ngClass]="'cs-rest-timer-pill__icon'" name="time"></cs-icon>
    <div class="cs-rest-timer-pill__time">{{ timeLabel() }}</div>
    <div class="cs-rest-timer-pill__name">{{ exerciseName() }}</div>
  </div>
</div>
